import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class app_custom_ds_get_shipment_pick_tasks_by_shipmentId_orderIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { orderId?: number, shipmentId?: number }): 
  Promise<{ result: { OrderId?: number, ShipmentId?: number, Shipment?: { Id?: number, BrokerReference?: string, ExpectedDate?: string, LookupCode?: string, Priority?: number, ReferenceNumber?: string, Tasks?: { Id?: number, ActualPackagedPackId?: number, ActualSourceLicensePlateId?: number, ChainHead?: number, ExpectedPackagedAmount?: number, ExpectedSourceLicensePlateId?: number, ExpectedSourceLocationId?: number, LotId?: number, MaterialId?: number, OrderLineNumber?: number, PickSlipId?: number, WarehouseId?: number, Material?: { LookupCode?: string } }[], LoadContainer?: { LookupCode?: string }, ActualWarehouse?: { Name?: string }, LicensePlates?: { Id?: number, Archived?: boolean, LookupCode?: string, TypeId?: number }[], ExpectedWarehouse?: { Name?: string } }, Order?: { Id?: number, LookupCode?: string, OrderClassId?: number, OwnerReference?: string, VendorReference?: string, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } } } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { orderId?: number, shipmentId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { OrderId?: number, ShipmentId?: number, Shipment?: { Id?: number, BrokerReference?: string, ExpectedDate?: string, LookupCode?: string, Priority?: number, ReferenceNumber?: string, Tasks?: { Id?: number, ActualPackagedPackId?: number, ActualSourceLicensePlateId?: number, ChainHead?: number, ExpectedPackagedAmount?: number, ExpectedSourceLicensePlateId?: number, ExpectedSourceLocationId?: number, LotId?: number, MaterialId?: number, OrderLineNumber?: number, PickSlipId?: number, WarehouseId?: number, Material?: { LookupCode?: string } }[], LoadContainer?: { LookupCode?: string }, ActualWarehouse?: { Name?: string }, LicensePlates?: { Id?: number, Archived?: boolean, LookupCode?: string, TypeId?: number }[], ExpectedWarehouse?: { Name?: string } }, Order?: { Id?: number, LookupCode?: string, OrderClassId?: number, OwnerReference?: string, VendorReference?: string, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } } } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { orderId?: number, shipmentId?: number, $keys: { OrderId?: number, ShipmentId?: number }[] }): 
  Promise<{ result: { OrderId?: number, ShipmentId?: number, Shipment?: { Id?: number, BrokerReference?: string, ExpectedDate?: string, LookupCode?: string, Priority?: number, ReferenceNumber?: string, Tasks?: { Id?: number, ActualPackagedPackId?: number, ActualSourceLicensePlateId?: number, ChainHead?: number, ExpectedPackagedAmount?: number, ExpectedSourceLicensePlateId?: number, ExpectedSourceLocationId?: number, LotId?: number, MaterialId?: number, OrderLineNumber?: number, PickSlipId?: number, WarehouseId?: number, Material?: { LookupCode?: string } }[], LoadContainer?: { LookupCode?: string }, ActualWarehouse?: { Name?: string }, LicensePlates?: { Id?: number, Archived?: boolean, LookupCode?: string, TypeId?: number }[], ExpectedWarehouse?: { Name?: string } }, Order?: { Id?: number, LookupCode?: string, OrderClassId?: number, OwnerReference?: string, VendorReference?: string, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } } } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      orderId?: number, shipmentId?: number    }) {
      return false;
    }
}
